import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Switch, Route, Link, useLocation, useHistory } from "react-router-dom";
import ArticleTab from './ArticleTab';
import AuthorsTab from './AuthorsTab';
import MetricsTab from './Metrics/MetricsTab';
import AttachmentsTab from './AttachmentsTab';
import NavBarItem from './NavBarItem';

const NavItems = ({hasAttachments, articleHtml, jels, metricsPaths, article, cssClass="", activeTab, setActiveTab, preview, page, fireAmplitude, currentUserId, scrollComments}) => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    setActiveTab(location.pathname)
    window.addEventListener('resize', () => handleAnimation());
    setCanonicalAndTitle()
    if(scrollComments) {
      scrollToComments()
    }
    // Cleanup function
    return () => {
      window.removeEventListener('resize', () => handleAnimation());
    };
  }, [])

  useEffect(() => {
    setActiveTab(location.pathname)
    setCanonicalAndTitle()
    MathJax.Hub.Queue(["Typeset",MathJax.Hub]);
    // Delay animation 
    setTimeout(() => {
      handleAnimation()
    }, 50)
  }, [location.pathname])
  const setCanonicalAndTitle = () => {
    if (!preview) {
      // setCanonical()
      setTitle()
    }
  }

  const setCanonical = () => {
    document.querySelector("link[rel='canonical']").href = window.location.href
  }

  const setTitle = () => {
    let tab = (location.pathname.split("/")[1] || "Article")
    tab = tab.charAt(0).toUpperCase() + tab.slice(1)
    if (tab) { document.title = `${article.title} | Cureus Journals | ${tab}` }
  }

  const handleAnimation = () => {
    if(cssClass !== "top-nav-links") {
      requestAnimationFrame(() => {
        let slideBubble = document.querySelector(".bubble");
        let navBar = document.querySelector('.main-nav-selector');
        
        if (!slideBubble || !navBar || navBar.offsetWidth === 0) {
          setTimeout(() => handleAnimation(), 50);
          return;
        }
        
        let navItems = Array.from(navBar.children);
        if (navItems.length === 0) return;
        
        // Find active tab index
        let activeIndex = 0;
        let activeLink = navBar.querySelector('.active');
        
        if (activeLink) {
          activeIndex = navItems.findIndex(item => item.contains(activeLink) || item === activeLink);
        } else {
          if (location.pathname === '/' || location.pathname === '') {
            activeIndex = 0;
          } else if (location.pathname === '/authors') {
            activeIndex = 1;
          } else if (location.pathname === '/media' && hasAttachments) {
            activeIndex = 2;
          }
        }
        
        if (activeIndex < 0 || activeIndex >= navItems.length) {
          activeIndex = 0;
        }
        
        // Calculate bubble position and size
        let activeNavItem = navItems[activeIndex];
        if (!activeNavItem) return;
        
        let activeRect = activeNavItem.getBoundingClientRect();
        let sliderRect = slideBubble.parentElement.getBoundingClientRect();
        
        let bubbleWidth = activeRect.width;
        let translate = activeRect.left - sliderRect.left;
        
        // Apply constraints
        let sliderWidth = slideBubble.parentElement.offsetWidth;
        let maxTranslate = sliderWidth - bubbleWidth;
        translate = Math.max(0, Math.min(translate, maxTranslate));
        
        slideBubble.style.width = bubbleWidth + 'px';
        slideBubble.style.transform = `translateX(${translate}px)`;
        slideBubble.classList.add('positioned');
      });
    }
  }

  const scrollToComments = () => {
    fireAmplitude("articleTabClicked", {article_id: article.id, source: 'Comments'})
    fireAmplitude("scrolledToComments", {article_id: article.id, source: 'tab'})
    history.push('/')
    setActiveTab('/')
    setTimeout(function() {
      const element = document.getElementById("article-comments-section");
      if (element) {
        const y = element.getBoundingClientRect().top + window.pageYOffset - 70;
        window.scrollTo({top: y, left: 0, behavior: 'smooth'});
      }
    }, 500)
  }

  const renderCss = () => {
    let navBarClass = "large-10 large-offset-1 medium-8 medium-offset-2 small-12 columns "
    if (cssClass === "top-nav-links") {
      return navBarClass + cssClass;
    } else {
      if(preview || page != 'article') {
        navBarClass = ((hasAttachments && page === 'article') ? "large-4 large-offset-4 medium-8 medium-offset-2 small-12 " : "large-2 large-offset-5 medium-4 medium-offset-4 small-12 ")
      }
      return navBarClass + "article-show-nav";
    }
  }

  return (
    <div className="row small-collapse">
      <div className="nav-container">
        <div className={renderCss()}>
          <ul className={"article-main-nav-links " + (cssClass === 'top-nav-links' ? '' : 'main-nav-selector')}>
            <NavBarItem
              setActiveTab={setActiveTab}
              activeTab={activeTab}
              name={"Article"}
              path={"/"}
              fireAmplitude={fireAmplitude}
              articleId={article.id}
              cssClass={cssClass}
            />
            <NavBarItem
              setActiveTab={setActiveTab}
              activeTab={activeTab}
              name={"Authors etc."}
              path={"/authors"}
              fireAmplitude={fireAmplitude}
              articleId={article.id}
              cssClass={cssClass}
            />
          {hasAttachments && page == "article" &&
              <NavBarItem
                setActiveTab={setActiveTab}
                activeTab={activeTab}
                name={"Media"}
                path={"/media"}
                fireAmplitude={fireAmplitude}
                articleId={article.id}
                cssClass={cssClass}
              />
          }
          {!preview && page == "article" &&
            <a onClick={scrollToComments} style={{cursor: 'pointer'}}>
              <li>
                Comments
              </li>
            </a>
          }
          </ul>
          {cssClass !== "top-nav-links" && <div className="slider">
            <div className="bubble"></div>
          </div>}
        </div>
      </div>
      {!cssClass &&
        <Switch>
          <Route exact path='/'>
            <ArticleTab
              preview={preview}
              html={articleHtml["article"]["html"]}
              jels={jels}
              article={article}
              page={page}
              articleId={article.id}
              fireAmplitude={fireAmplitude}
              currentUserId={currentUserId}
            />
          </Route>
          <Route path='/authors'>
            <AuthorsTab html={articleHtml["authors"]["html"]}/>
          </Route>
          <Route path='/media'>
            <AttachmentsTab html={articleHtml["figures"] ? articleHtml["figures"]["html"] : {}}/>
          </Route>
        </Switch>
      }
    </div>
  )

}

export default NavItems;